import { render } from "./MobileLogo.vue?vue&type=template&id=30b46a51&ts=true"
import script from "./MobileLogo.vue?vue&type=script&lang=ts"
export * from "./MobileLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__